/**
 * Public API access for the participant flow (§48–§53): query keys, the code check with optional
 * Turnstile header and the polled registration status.
 */
import { queryOptions } from '@tanstack/react-query';
import { type ActivationCheckResponse, TURNSTILE_TOKEN_HEADER } from '@lsc/shared';
import { apiRequest } from '../api/client';

export const publicQueryKeys = {
  activationCheck: (code: string, turnstileToken: string | null) =>
    ['public', 'activation', code, turnstileToken] as const,
  registrationStatus: ['public', 'registration', 'status'] as const,
};

/**
 * GET /api/v1/public/activation/:code. After repeated failures the server demands a Turnstile
 * token in `X-Turnstile-Token` (TURNSTILE_REQUIRED, ADR 035).
 */
export async function checkActivationCode(
  code: string,
  turnstileToken: string | null,
  signal?: AbortSignal,
): Promise<ActivationCheckResponse> {
  return apiRequest(
    'checkActivationCode',
    { params: { code } },
    {
      ...(signal === undefined ? {} : { signal }),
      ...(turnstileToken === null ? {} : { headers: { [TURNSTILE_TOKEN_HEADER]: turnstileToken } }),
    },
  );
}

export const registrationStatusQuery = queryOptions({
  queryKey: publicQueryKeys.registrationStatus,
  queryFn: ({ signal }) => apiRequest('registrationStatus', {}, { signal }),
});
